module.exports = __webpack_public_path__ + "img/story-5.c686e5db.webp";